<template>
  <div id="tela-selfie">
    <div class="captura" :class="{'hidden':isError}">
      <div id="selfie"></div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="this.reloadComponent"
      ></Error>
    </div>
  </div>
</template>

<script>

import Error from "../shared/Error";
import DispatchTags from "../../utils/DispatchTags";
import LoadScriptFilesService from "../../services/LoadScriptFilesService";
import AppService from "../../services/AppService";
import LivenessLogService from "../../services/LivenessLogService";
import jwtDecode from "jwt-decode";

const ERROR = {
  title: "Não conseguimos tirar a foto do seu rosto",
  subtitle: "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente",
  btnTitle: "Tentar novamente",
};

const ERROR_ACESSO_CAMERA = {
  title: "Algo deu errado ao acessar sua câmera",
  subtitle: "Precisamos do acesso pra tirar a foto e confirmar sua identidade",
  btnTitle: "Permitir acesso à câmera",
};
const SELFIE_FILE_CSS = "@/../static/selfie/livenessSerasa/livenessSerasa.css";
export default {
  name: "LivenessSerasa",
  components: {Error},
  data(){
    return {
      isError: false,
      error: {
        title: ERROR.title,
        subtitle: ERROR.subtitle,
        btnTitle: ERROR.btnTitle
      },
      intervalCallack:null,
      logLiveness: null,
      acessoCamera:false
    }
  },
  beforeRouteEnter(to, from, next) {
    let l = new LoadScriptFilesService();
    l.head_link(SELFIE_FILE_CSS)
        .then(() => next())
        .catch(() => alert("Falha ao carregar arquivo"));
  },
  beforeRouteLeave(to, from,next) {
    let l = new LoadScriptFilesService();
    l.del_link(SELFIE_FILE_CSS);
    this.pararDOMNodeInserted();
    this.stopStream();
    next();
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", true);
  },
  mounted() {
    this.logLivenessService = new LivenessLogService();
    this.appService = new AppService();
    this.appService.carregarComponentSelefie();
    DispatchTags.dispatchScreenView("Selfie");
    var interval = setInterval(_ => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.selfie = window.selfie;
      this.iniciarSelfie();
      clearInterval(interval);
    }, 100);
  },
  methods:{
    iniciarSelfie:async function (){
      let contextualDevice = await this.getContextualDevice();
      this.iniciarDOMNodeInserted();
      this.selfie
          .iniciaSelfie(document.getElementById('selfie'),null,contextualDevice)
          .then(res => {
            let sessionId = 'nlvnsrsexp';
            this.$store.dispatch("setLoadingStatus", true);
            sessionStorage.setItem("s", res.selfie);
            sessionStorage.setItem("selfie_msg", res.msg);
            sessionStorage.setItem("selfie_id", res.id);
            this.logLivenessService.sendLogLiveness(1,sessionId,null,null).finally(_ => {
              this.nextPage();
            });
          })
          .catch(e => {
            this.$store.dispatch("setLoadingStatus", true);
            this.stopStream();
            let sessionId = 'nlvnsrsexp';
            this.logLivenessService.sendLogLiveness(2,sessionId,e.id,e.desc).finally(_ => {
              DispatchTags.dispatchScreenView('SelfieError');
              DispatchTags.dispatchNoninteraction('SelfieError');
              if(e.id == 11){
                let i = ERROR_ACESSO_CAMERA;
                this.showError(i.title,i.subtitle,i.btnTitle);
                return;
              }
            if(e.id == 15){
              this.showError(ERROR_ACESSO_CAMERA.title,'Para continuar, verifique as configurações do seu dispositivo.',null);
              return;
            }
              this.showError(null,e.desc);
            });
          });
    },
    getContextualDevice:async function (){
      let contextualDevice = null;
      if (window['Alwm'] !== undefined) {
        const alwCollect = await Alwm.collect({ metadata: { eventName: 'liveness' }, timeout: 10000 });
        const data = jwtDecode(this.$store.state.token_serasa);
        contextualDevice = {
          userId: data.peopleId, // passar o cpf do usuário
          event: alwCollect
        }
      }
      return contextualDevice;
    },
    reloadComponent() {
      let tag = (this.acessoCamera) ? 'ModalCamera' : 'SelfieError';
      DispatchTags.dispatchInraction(tag);
      this.acessoCamera = false;
      this.$store.dispatch("setLoadingStatus", true);
      this.$router.replace({name:'ConfirmarIdentidade'}).then(_ => {
        this.appService.preLoadSelefie(true);
      });
    },
    nextPage(){
      this.appService.nextPageLiveness();
    },
    showError(title,subtitle,btnTitle) {
      if (this.isError) {
        return;
      }
      let l = new LoadScriptFilesService();
      l.del_link(SELFIE_FILE_CSS);
      this.error.title = title ? title : ERROR.title;
      this.error.subtitle = subtitle ? subtitle : ERROR.subtitle;
      this.error.btnTitle = btnTitle ? btnTitle : ERROR.btnTitle;
      this.isError = true;
      this.$store.dispatch("setLoadingStatus", false);
    },
    videoIniciou() {
      var cameraVideo = document.getElementsByTagName('video');
      if (cameraVideo.length === 0) {
        return;
      }
      if(!window.selfieVideoStream){
        window.selfieVideoStream  =  window.selfie.camera.videoStream;
      }
      cameraVideo = cameraVideo[0];
      cameraVideo.autoplay = true;
      cameraVideo.addEventListener("click", () => cameraVideo.play(), false);
      $(cameraVideo).trigger("click");
      DispatchTags.dispatchNoninteraction("SelfieReady");
      window.selfieVideoStream = this.selfie.camera.videoStream;
      this.$store.dispatch("setLoadingStatus", false);
    },
    iniciarDOMNodeInserted(){
      //quando um elemento video é inserido no dom chama a função videoIniciou
      this.observer = new MutationObserver(mutationList =>
          mutationList.filter(m => m.type === 'childList').forEach(m => {
            m.addedNodes.forEach(a => {
              if(a.nodeName.toLowerCase() == 'video'){
                this.pararDOMNodeInserted();
                this.videoIniciou();
              }
            });
          }));
      this.observer.observe(window.document.body,{childList: true, subtree: true});
    },
    pararDOMNodeInserted(){
      //para de observar quando o elemento video é inserido no dom
      this.observer.disconnect();
    },
    stopStream() {
      if(window.selfieVideoStream) {
        window.selfieVideoStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LivenessSerasa.vue